var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneStateChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.25 0 0 2.25 0 5C0 7.75 2.25 10 5 10C7.75 10 10 7.75 10 5C10 2.25 7.75 0 5 0ZM7.31687 4.19187L4.81687 6.69187C4.695 6.81375 4.535 6.875 4.375 6.875C4.215 6.875 4.055 6.81375 3.93313 6.69187L2.68313 5.44187C2.43875 5.1975 2.43875 4.8025 2.68313 4.55813C2.9275 4.31375 3.3225 4.31375 3.56687 4.55813L4.375 5.36625L6.43313 3.30813C6.6775 3.06375 7.0725 3.06375 7.31687 3.30813C7.56125 3.5525 7.56125 3.9475 7.31687 4.19187Z",
    fill: "#3DA64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneStateChange);
export default __webpack_public_path__ + "static/media/doneStateChange.8e65f71b36169ed329c7c654d513fc20.svg";
export { ForwardRef as ReactComponent };